// extracted by mini-css-extract-plugin
export default {"faq-details":"faq_faq-details__cediE"};